export default __webpack_public_path__ + "static/media/newimg.cdc5478c.jpg";